export default __webpack_public_path__ + "static/media/SLIDER-DD-Xpress-Delivery.cfffc1ea.png";